module.exports = __webpack_public_path__ + "img/zip.839d61e0.svg";